module.exports = __webpack_public_path__ + "img/jiuzhou-boss.c49562b9.png";